module.exports = __webpack_public_path__ + "static/media/hero-4.24583a3a.png";